export const APP_ENV_VALUES = ['local', 'dev', 'demo', 'prod'] as const

export type AppEnv = (typeof APP_ENV_VALUES)[number]

const APP_ENV_SET = new Set<string>(APP_ENV_VALUES)

export function isAppEnv(value: string): value is AppEnv {
    return APP_ENV_SET.has(value)
}

export function getAppEnv(): AppEnv {
    // APP_ENV fallback kept while secrets are rotated to NEXT_PUBLIC_APP_ENV — remove after migration.
    const env = process.env.NEXT_PUBLIC_APP_ENV ?? process.env.APP_ENV
    if (env && isAppEnv(env)) {
        return env
    }
    return 'local'
}
